import _ from 'lodash';

class Context {
  constructor(manager, register, unregister, priority) {
    this.manager = manager;
    this.register = register;
    this.unregister = unregister;
    this.priority = priority;
  }

  remove() {
    this.manager._remove(this);
  }
}

class ContextManager {
  contexts = [];
  active = null;
  nextIndex = 0;

  add({register, unregister, priority = 0}) {
    const actualPriority = priority * 100000 + this.nextIndex++;
    const context = new Context(this, register, unregister, actualPriority);
    const index = _.sortedIndexBy(this.contexts, context, o => -o.priority);
    this.contexts.splice(index, 0, context);
    this.updateActive();
    return context;
  }

  _remove(context) {
    if (context === this.active) {
      this.active.unregister();
      this.active = null;
    }
    this.contexts = this.contexts.filter(o => o !== context);
    this.updateActive();
  }

  updateActive() {
    if (this.contexts.length > 0) {
      if (this.active !== this.contexts[0]) {
        if (this.active) {
          this.active.unregister();
        }
        this.active = this.contexts[0];
        this.active.register();
      }
    }
  }
}

const manager = new ContextManager();
export default manager.add.bind(manager);